export const LineSegments = 'LineSegments';
export const PointLight = 'PointLight';
export const PerspectiveCamera = 'PerspectiveCamera';
export const AxesHelper = 'AxesHelper';
export const Mesh = 'Mesh';
